import "./Service.scss";
import {BookOpenText, Boxes, Palette, Globe, Megaphone, Users} from "lucide-react";
import { useTranslation } from "react-i18next";

type ServiceIcon =
    | "MegaPhone"
    | "user"
    | "file"
    | "palette"
    | "Block"
    | "Web";

type ServiceItem = {
    number: string;
    icon: ServiceIcon;
};

const ourServices: ServiceItem[] = [
    {
        number: "01",
        icon: "MegaPhone",
    },
    {
        number: "02",
        icon: "user",
    },
    {
        number: "03",
        icon: "file",
    },
    {
        number: "04",
        icon: "palette",
    },
    {
        number: "05",
        icon: "Block",
    },
    {
        number: "06",
        icon: "Web",
    },
];

function ServiceIconComponent({
                                  type,
                              }: {
    type: ServiceIcon;
}) {
    switch (type) {
        case "MegaPhone":
            return <Megaphone />

        case "user":
            return <Users />

        case "file":
            return <BookOpenText />

        case "palette":
            return <Palette />

        case "Block":
            return <Boxes />

        case "Web":
            return <Globe />

        default:
            return null;
    }
}

export default function OurService() {
    const { t } = useTranslation();
    return (
        <section className="growth-services">
            <div className="growth-services__container">
                <header className="growth-services__header">
                    <h2>{t("home.service.title")}</h2>

                    <p>{t("home.service.subtitle")}</p>
                </header>

                <div className="services-grid">
                    {ourServices.map((service) => (
                        <article
                            key={service.number}
                            className={"service-card"}
                        >
                            <div className="service-card__icon">
                                <ServiceIconComponent type={service.icon} />
                            </div>

                            <div className="service-card__content">
                                <h3>{t(`home.service.${service.number}.title`)}</h3>
                                <p>{t(`home.service.${service.number}.subtitle`)}</p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
